import { connect } from 'react-redux';
import filter from 'lodash/filter';

import FeaturedListingCollection from './FeaturedListingCollection';

import { emitTrackImpressionForPropertyCardEvent } from 'app/shared/models/Clickstream/ListingCardClickstreamEvents';

import type { RootReduxState } from '../../flux/reducers';
import type { ListingDetails } from '@/srcLegacy/types/listingDetails.type';
import type { ListingType } from '@/srcLegacy/types';
import type { SimilarListingDetails } from '@/srcLegacy/types/similarListingDetails.type';
import type { HotpadsListing } from '@/srcLegacy/client/analytics/types';

interface PetFriendlyListingsProps {
  petFriendlyListings: Array<ListingDetails>;
  areaName: string;
  onListingClick: () => void;
  screenWidthForDesktopSRPFilter: 'sm' | 'md' | 'lg' | 'xl';
}

const PetFriendlyListings = ({
  petFriendlyListings,
  areaName,
  onListingClick,
  screenWidthForDesktopSRPFilter,
}: PetFriendlyListingsProps) => {
  if (petFriendlyListings.length === 0) {
    return null;
  }

  const trackImpression = (listing: ListingType | SimilarListingDetails) => {
    emitTrackImpressionForPropertyCardEvent({
      listing: listing as HotpadsListing,
      triggerLocation: 'pet_friendly_rentals_nearby_module',
    });
  };

  const header = areaName ? `Pet friendly rentals in ${areaName}` : 'Pet friendly rentals';

  return (
    <FeaturedListingCollection
      header={header}
      listings={petFriendlyListings}
      onListingClick={onListingClick}
      screenWidthForDesktopSRPFilter={screenWidthForDesktopSRPFilter}
      trackImpression={trackImpression}
      triggerLocation={'home_details'}
      triggerObject={'home_details_component|pet_friendly'}
    />
  );
};

const mapStateToProps = (state: RootReduxState) => {
  return {
    petFriendlyListings: filter(state.listings.listingGroups.petFriendly, (listing) => {
      // Filter out the current listing
      if (
        state.location.current.pathname === listing.uriMalone ||
        state.location.current.pathname === listing.uriBuilding ||
        state.location.current.pathname === listing.uriV2
      ) {
        return false;
      }
      return true;
    }),
    areaName: state.area.area?.name || '',
  };
};

export default connect(mapStateToProps)(PetFriendlyListings);
